module.exports = __webpack_public_path__ + "img/le-village.227bba4a.png";